import { ProcedureConstants } from './procedure.constants'
import { IProcedureState } from './procedure.types'

export const initialProcedureState: IProcedureState = {
  assessedByOptions: [],
  type: '',
  inputRows: [],
  complicationsOptions: [],
  responseOptions: [],
  authorizationOptions: [],
  rolePerformingOptions: [],
  isFirstVisit: false,
  nemsisCodeOptions: [],
}

export function procedureReducer(state: IProcedureState = initialProcedureState, action: any): IProcedureState {
  switch (action.type) {
    case ProcedureConstants.SET_ASSESSED_BY_OPTIONS:
      return { ...state, assessedByOptions: action.assessedByOptions }
    case ProcedureConstants.SET_AUTHORIZATION_OPTIONS:
      return { ...state, authorizationOptions: action.authorizationOptions }
    case ProcedureConstants.SET_COMPLICATIONS_OPTIONS:
      return { ...state, complicationsOptions: action.complicationsOptions }
    case ProcedureConstants.SET_RESPONSE_OPTIONS:
      return { ...state, responseOptions: action.responseOptions }
    case ProcedureConstants.SET_ROLE_PERFORMING_OPTIONS:
      return { ...state, rolePerformingOptions: action.rolePerformingOptions }
    case ProcedureConstants.SET_NEMSIS_CODE_OPTIONS:
      return { ...state, nemsisCodeOptions: action.nemsisCodeOptions }
    case ProcedureConstants.SET_INPUT_ROWS:
      return { ...state, inputRows: action.inputRows }
    case ProcedureConstants.SET_IS_FIRST_VISIT:
      return { ...state, isFirstVisit: action.isFirstVisit }
    default:
      return state
  }
}
